import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { usePresentation } from '@context/presentation';
import { SectionLabel, GridList } from '../shared';
import { SlideSection, SectionHeader } from '../styles';
import { useSlideData } from '@context/slide-data';
import { isAttorneyProfile } from '@utils/profileUtils';
import { UNAVAILABLE_CS_FIRM } from '@constants';

const WeCanHelpStyle = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
    >div:nth-of-type(1) {
        margin-bottom: 25px;
    }
    >div {
        font-size: 14px;
    }
`;

export const WeCanHelp = () => {
    const { t } = useTranslation();
    const { client } = usePresentation();
    const { firmShortName } = client;
    const { data, slideState, sectionsVisible } = useSlideData();
    const { id } = data;
    const selected = slideState.selectedSection ? slideState.selectedSection[id] : null;

    // This works fine, except for bolding the firmShortName name, which is pretty annoying. Will come back to that.
    const profileBioOne = `${t('we_can_help.profile.about_1')} ${t('we_can_help.at')} `;
    const profileBioTwo = `${t('we_can_help.profile.about_2')} `;
    const lawFirmBioOne = `${t('we_can_help.law_firm.about_1')} ${t('we_can_help.at')} `;
    const lawFirmBioTwo = `${t('we_can_help.law_firm.about_2')} `;
    const lawFirmBioThree = t('we_can_help.law_firm.about_3');

    const isLawFirm = isAttorneyProfile(firmShortName);
    const firmToRender = firmShortName === UNAVAILABLE_CS_FIRM ? '(Insert Firm Here)' : firmShortName;

    const gridOptions = [
        t('we_can_help.benefits.single_payment'), 
        t('we_can_help.benefits.reduced_debt'),
        t('we_can_help.benefits.average_years'),
        t('we_can_help.benefits.zero_interest')
    ];

    return (
        <WeCanHelpStyle>
            <SectionHeader>{t('we_can_help.who_we_are')}</SectionHeader>
            <SlideSection
                visible={sectionsVisible}
                selected={selected === 1}>
                    <SectionLabel section={1} />
                        <strong>{firmToRender}</strong>
                        { isLawFirm ? lawFirmBioOne : profileBioOne }
                        <strong>{firmToRender}</strong>
                        { isLawFirm ? lawFirmBioTwo : profileBioTwo }
                        { isLawFirm && <strong>{firmToRender}</strong>}
                        { isLawFirm && lawFirmBioThree}
            </SlideSection>
            <SlideSection
                visible={sectionsVisible}
                selected={selected === 2}>
                <SectionLabel section={2} />
                <label>
                    <SectionHeader>{t('we_can_help.benefits.header')}</SectionHeader>
                </label>
                <GridList options={gridOptions} />
            </SlideSection>
        </WeCanHelpStyle>
    );
};

export default WeCanHelp;
